/**
 * The local storage key for the application query params the app initially received.
 * Used for temporarily storing the query params so that they can be restored after the redirections and the login flow.
 * Note that not all query params should be saved here - only specific ones that
 * that aren't mission-critical and should persist and that are likely to be forwarded again - such as the axpetio cookie consent token.
 */
export const AppLoadQueryParams = 'AppLoadQueryParams';
